import React from 'react';
import API from "../../Services/BaseService";
import { useHistory } from "react-router-dom";
import ls from 'local-storage';
import { useState } from 'react';
import { useEffect } from 'react';
import '../../assets/css/responsive.css';
import ManageAccountLinks from "../../Component/ManageAccountLinks/ManageAccountLinks"
import { Button } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import appstore from '../../assets/img/appstore.png';
import googleplay from '../../assets/img/googleplay.png';
import download from '../../assets/img/download.png';
import Loading from "../../Component/Loading/Loading";
import PageNotFound from '../FallBackUI/PageNotFound';
import DealerAction from '../DealerRedux/DealerAction';

const PaymentInfo = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [paymentinfo, setPaymentInfo] = useState("");
    const successData = useSelector(state => state.LoginReducer.payload);
    const dealerData = useSelector(state => state.DealerReducer.payload);

    const [dealerList, setDealerList] = useState("");
    const [dealerId, setDealerId] = useState("");
    console.log("setDealerId1233", dealerId);
    const [selectedSellerDetails, setSelectedSellerDetails] = useState("");
    const [flagFilter, setFalgFilter] = useState(false);
    const [selectSellerId, setselectSellerid] = useState("");

    const [errors, setErrors] = useState("");
    const [errorFlag, setErrorFlag] = useState(false);

    let userDetails = ls.get('userDetails');
    async function getPaymentInfo(data) {
        let request = {
            // seller_dealer_id:  data == undefined ?dealerData !== null ? dealerData.seller_dealer_id: successData.seller_dealer_id :data,
            seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,

            seller_id: successData.seller_id,
            seller_token: successData.seller_token,
        };
        const state = API.post('seller_payment_info/condition', request);
        state.then(res => {
            console.log("res", res.data.data)
            if (res.data.success === true) {
                setPaymentInfo(res.data.data);
                setLoading(false);
            }
            else {
                setErrors(res.data.error)
                setErrorFlag(true)
            }

        })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                    setLoading(false);
                }
            });
    }
    function onHandleEdit(e) {
        history.push("/editpayment/" + e);
    }
    useEffect(() => {
        getPaymentInfo(dealerData)
        getDealername();
        // fetchState();
    }, [dealerData]);

    const handleSellerDetailsName = (e, flag) => {

        setDealerId(e.target.value)
        console.log("=========check seller details name", e.target.value)
        setSelectedSellerDetails(dealerList.filter(data => data.seller_dealer_id == e.target.value)[0])
        console.log("=========check", dealerList.filter(data => data.seller_dealer_id == e.target.value))
        const selectedSellerDetails = dealerList.filter(data => data.seller_dealer_id == e.target.value)[0];
        getfileterPayment(selectedSellerDetails);
        setselectSellerid(selectedSellerDetails.seller_dealer_id)
        setFalgFilter(true)
        dispatch(DealerAction.searchrequest(selectedSellerDetails));
    }

    useEffect(() => {
        if (dealerData !== null) {

            getfileterPayment(dealerData);
        }
    }, [dealerData])

    const getDealername = (data) => {

        let request = {
            seller_id: successData.seller_id,
            seller_token: successData.seller_token,
        }
        API.post("dealerNameDynamic/condition", request).then(response => {
            if (response.data.success === true) {


                setDealerList(response.data.data);

            }

            else {
                setErrors(response.data.error.name)
                setErrorFlag(true)
            }


        })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                }
            });
    }

    const getfileterPayment = (data) => {

        let request = {
            seller_dealer_id: data.seller_dealer_id,
            seller_id: successData.seller_id,
            seller_token: successData.seller_token
        }
        API.post("seller_payment_infoFilter/condition", request).then(response => {
            if (response.data.success === true) {
                setPaymentInfo(response.data.data);
            }

            else {
                setErrors(response.data.error.name)
                setErrorFlag(true)
            }
        })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                }
            });
    }
    const handleFileDownload = async (fileUrl) => {
        const fileName = fileUrl.split('/').pop();

        try {
            const response = await fetch(fileUrl, {
                headers: {
                    'Accept': '*/*',
                },
            });

            if (!response.ok) {
                throw new Error(`Download failed: ${response.status}`);
            }

            // Get the blob
            const blob = await response.blob();

            // Create object URL
            const url = window.URL.createObjectURL(blob);

            // Create download link
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            link.style.display = 'none';
            document.body.appendChild(link);

            // Trigger download
            link.click();

            // Clean up
            setTimeout(() => {
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }, 1000);

        } catch (error) {
            console.error('Download failed:', error);
            // Fallback: Open in new tab
            window.open(fileUrl, '_blank');
        }
    };
    function determineContentType(fileExtension) {
        switch (fileExtension) {
            case 'jpeg':
            case 'jpg':
                return 'image/jpeg';
            case 'png':
                return 'image/png';
            case 'pdf':
                return 'application/pdf';
            case 'doc':
                return 'application/msword';
            case 'docx':
                return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            default:
                return 'application/octet-stream';
        }
    }
    function getDocumentType(url) {
        // Extract the file extension
        const extension = url.split('.').pop().toLowerCase();
        console.log("extension", extension)
        return extension;
    }
    const convertToBase64 = (file, callback) => {
        const reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = () => {
            callback({
                name: file.name,
                type: file.type,
                size: file.size,
                base64: reader.result,
                file: reader
            });
        };

        reader.onerror = (error) => {
            console.error("File reading error:", error);
        };
    };
    return (
        <div>
            {loading ? <Loading /> :
                <main id="main" className="inner-page">

                    {errorFlag === true ? <PageNotFound error={errors} /> :
                        <div id="paymentaccount" className="paymentaccount">
                            <div className="container-fluid inner-page-space" >
                                <div class="common-heading mb-2">
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <div class="back-btn">
                                                <a class="back-btn-primary" onClick={() => history.push("/carlist")}>
                                                    <i class="bx bx-chevron-left"></i> Back
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-4">
                                            <div class="title">
                                                <p class="inner-title">Financials</p>
                                            </div>
                                        </div>
                                        <div className="col-lg-4">

                                            <div class="title-dropdown">
                                                <select class="form-control box " id="drop" placeholder="" className={`${dealerData != null ? (dealerData?.color == "pink"
                                                    ? "tableRowPink  form-control box"
                                                    : dealerData?.color == "firered"
                                                        ? "tableRowFireRed  form-control box"
                                                        : dealerData?.color == "green"
                                                            ? "tableRowGreenColor form-control box"
                                                            : dealerData?.color == "darkred"
                                                                ? "tableRowRed1  form-control box"
                                                                : " form-control box") :
                                                    (dealerList[0]?.color == "pink"
                                                        ? "tableRowPink  form-control box"
                                                        : dealerList[0]?.color == "firered"
                                                            ? "tableRowFireRed  form-control box"
                                                            : dealerList[0]?.color == "green"
                                                                ? "tableRowGreenColor form-control box"
                                                                : dealerList[0]?.color == "darkred"
                                                                    ? "tableRowRed1  form-control box"
                                                                    : " form-control box")
                                                    }`} onChange={handleSellerDetailsName}>
                                                    {dealerData != null ?
                                                        <option value={null} style={{ "display": "none" }}>{dealerData.dealer_name}({dealerData?.seller_dealer_id})</option> :
                                                        <option value={null} style={{ "display": "none" }}>{dealerList[0]?.dealer_name}({dealerList[0]?.seller_dealer_id})</option>}
                                                    {dealerList.length > 0 &&
                                                        <>
                                                            {dealerList.map((dealerList, index) => <option className={dealerList?.color == "pink"
                                                                ? "tableRowPink  user_name"
                                                                : dealerList?.color == "Silver"
                                                                    ? "tableRowSilver  user_name"
                                                                    : dealerList?.color == "Orange"
                                                                        ? "tableRowOrange  user_name"
                                                                        : dealerList?.color == "Navy blue"
                                                                            ? "tableRowNavyBlue  user_name"
                                                                            : dealerList?.color == "firered"
                                                                                ? "tableRowFireRed  user_name"
                                                                                : dealerList?.color == "Purple"
                                                                                    ? "tableRowPurple  user_name"
                                                                                    : dealerList?.color == "Yellow"
                                                                                        ? "tableRowYellow1  user_name"
                                                                                        : dealerList?.color == "green"
                                                                                            ? "tableRowGreenColor user_name"
                                                                                            : dealerList?.color == "blue"
                                                                                                ? "tableRowBlue  user_name"
                                                                                                : dealerList?.color == "darkred"
                                                                                                    ? "tableRowRed1  user_name"
                                                                                                    : dealerList?.color == "black"
                                                                                                        ? "tableRowBlack1 user_name"
                                                                                                        : " user_name"} key={dealerList.seller_dealer_id} value={dealerList.seller_dealer_id}  >{dealerList.dealer_name}({dealerList?.seller_dealer_id})</option>)}
                                                        </>
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="paymentaccountblock">
                                    <div className="row content">
                                        <div className="col-lg-4 col-md-12 col-sm-12 accountleftblock">
                                            <ManageAccountLinks />
                                        </div>
                                        <div className="col-lg-8 col-md-12 col-sm-12  paymentrightblock ">
                                            <div className="paymentdetailblock">
                                                <p>Thank you for providing us the information of your bank system. We are going to use this for making charges to your account whenever you purchase a car to assure easy transaction for your business</p>
                                                <div className="add-floors">
                                                    <div className="add-accounts">
                                                        {/* <Button className="add-account-btns" onClick={() => history.push("/payment")}><i className="icofont-plus"></i> Add Bank Account</Button> */}
                                                        <Button className="add-account-btns" onClick={() => history.push({
                                                            pathname: "/payment", state: { flagFilter: flagFilter, selectSellerId: selectSellerId }
                                                        })}><i className="icofont-plus"></i> Add Bank Account</Button>
                                                        {/*<a className="add-account-btns" href="/payment"><i class="icofont-plus"></i> Add Bank Account</a> */}
                                                    </div>

                                                </div>
                                                {paymentinfo.length > 0 ? paymentinfo.map((item, index) =>
                                                    <div className="col-lg-12 col-md-12 col-sm-12 bankinfo paymentinfoblocks">
                                                        <div className="bankinfos">
                                                            <h4>Bank Account Information</h4>
                                                            <div className="bankinfotable">
                                                                <div class="table-responsive">
                                                                    {/* <Button onClick={() => onHandleEdit(item.payment_info_id)}>Edit</Button> */}
                                                                    <table>
                                                                        <tr>
                                                                            <td><span>Dealership Name</span></td>
                                                                            <td>{item.dealership_name}</td>
                                                                            <td><span>ACH Number</span></td>
                                                                            <td>{item.ach_no}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td><span>Signer on Account</span></td>
                                                                            <td>{item.acc_name}</td>
                                                                            <td><span>Routing Number</span></td>
                                                                            <td>{item.routing_no}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td><span>Bank Name</span></td>
                                                                            <td>{item.bank_name}</td>
                                                                            <td><span>Bank Address</span></td>
                                                                            <td>{item.bank_address}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td><span>Account Number</span></td>
                                                                            <td>{item.acc_no}</td>
                                                                            <td><span>Account Holder Address</span></td>
                                                                            <td>{item.acc_address}</td>
                                                                        </tr>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                            <div className="releaseinfo">
                                                                <div className="row">
                                                                    <div className="col-sm-12">
                                                                        <p>Signed bank Authorization letter for bank to release information. </p>
                                                                        <div className="uploadbutton">
                                                                            <a onClick={() => handleFileDownload(item.doc_name)}>
                                                                                <label htmlFor="downupload"><img src={download} />Documents</label></a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>) : ""}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>









                            <section id="playstoreBlock" className="playstoreBlock">
                                <div className="container">


                                    <div className="row content">
                                        <div className="col-lg-12">
                                            <img src={appstore} />
                                            <img src={googleplay} />
                                        </div>

                                    </div>

                                </div>
                            </section>

                        </div>}



                </main>}

        </div>


    );
};

export default PaymentInfo;